<app-layout title="Descuentos del Empleado">
    <div class="row p-4">
        <!-- Selección de Usuario -->
        <div class="col-md-3">
            <label for="filterUser" class="form-label fw-bold">Usuario</label>
            <select id="filterUser" class="form-select" [(ngModel)]="selectedUserId">
                <option value="" disabled selected>Seleccione un usuario</option>
                 <option *ngFor="let u of users" [value]="u._id">{{ u.name }}</option>
            </select>
        </div>

        <!-- Selección de Periodo -->
        <div class="col-md-3">
            <label for="filterPeriod" class="form-label fw-bold">Periodo</label>
            <select id="filterPeriod" class="form-select" [(ngModel)]="selectedPeriod">
                <option value="" disabled selected>Seleccione un periodo</option>
                <option *ngFor="let p of periods" [ngValue]="p">{{p.name}}</option>
            </select>
        </div> 

        <!-- Botón de búsqueda -->
        <div class="col-md-2 mt-4">
            <button class="btn btn-primary btn-sm w-100" (click)="searchDiscount()" [disabled]="selectedPeriod==''|| selectedUserId==''">Buscar</button>
        </div>

         <div class="col-md-2 mt-4">
            <button class="btn btn-secondary btn-sm w-100" (click)="generateResumeDiscounts()">
                Resumen Descuentos
            </button>   
        </div>

        <!-- Botón para agregar descuento -->
        <div class="col-md-2 mt-4">  <!-- d-flex align-items-end justify-content-end -->
            <button class="btn btn-success btn-sm w-100" (click)="openModal()">
                Agregar Descuento
            </button>
        </div>

    </div>
    <div class="p-4">
        <app-list-discounts></app-list-discounts>
    </div>
</app-layout>
